<template>
  <div>
    <section>
      <div class="form-inline flex-row">
        <label>Payment Type:</label>
        <div>
          <model-select
            :options="paymentTypeOptions"
            placeholder="Payment Type"
            v-model="editPaymentType"
          ></model-select>
        </div>
      </div>
      <div v-if="editPaymentType == 1">
        <div class="form-inline flex-row">
          <label>Name:</label>
          <div>
            <input type="text" placeholder="Name" v-model="editBankName" />
          </div>
        </div>
        <div class="form-inline flex-row">
          <label>Holder Type:</label>
          <div>
            <model-select
              :options="holderTypeOptions"
              placeholder="Holder Type"
              v-model="editBankHolderType"
            ></model-select>
          </div>
        </div>
        <div class="form-inline flex-row">
          <label>Routing Number:</label>
          <div>
            <input
              type="text"
              placeholder="Routing Number"
              v-model="editBankRoutingNumber"
            />
          </div>
        </div>
        <div class="form-inline flex-row">
          <label>Account Number:</label>
          <div>
            <input
              type="text"
              placeholder="Account Number"
              v-model="editBankAccountNumber"
            />
          </div>
        </div>
        <div class="form-inline flex-row">
          <label>Confirm Number:</label>
          <div>
            <input
              type="text"
              placeholder="Confirm Number"
              v-model="editBankConfirmNumber"
            />
          </div>
        </div>
      </div>
      <div v-show="editPaymentType == 2">
        <div class="form-inline flex-row">
          <div class="card-wrapper">
            <div id="card-element"></div>
          </div>
        </div>
        <!-- <div class="form-inline flex-row">
          <label>Number:</label>
          <div>
            <input type="text" placeholder="Number" v-model="editCardNumber" />
          </div>
        </div>
        <div class="form-inline flex-row">
          <label>Expire Month:</label>
          <div>
            <model-select
              :options="expireMonthOptions"
              placeholder="Expire Month"
              v-model="editCardExpireMonth"
            ></model-select>
          </div>
        </div>
        <div class="form-inline flex-row">
          <label>Expire Year:</label>
          <div>
            <model-select
              :options="expireYearOptions"
              placeholder="Expire Year"
              v-model="editCardExpireYear"
            ></model-select>
          </div>
        </div>
        <div class="form-inline flex-row">
          <label>CVC:</label>
          <div>
            <input type="text" placeholder="CVC" v-model="editCardCvc" />
          </div>
        </div> -->
      </div>
      <div class="form-inline flex-row">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
          >Add Payment Method</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import spinnerButton from "@/components/public/SpinnerButton";
import { loadStripe } from "@stripe/stripe-js/pure";

export default {
  props: ["submitLoading"],
  components: {
    ModelSelect,
    spinnerButton,
  },
  data() {
    return {
      editPaymentType: null,

      editBankName: null,
      editBankHolderType: null,
      editBankRoutingNumber: null,
      editBankAccountNumber: null,
      editBankConfirmNumber: null,

      editCardNumber: null,
      editCardExpireYear: null,
      editCardExpireMonth: null,
      editCardCvc: null,

      paymentTypeOptions: null,
      holderTypeOptions: null,
      expireYearOptions: null,
      expireMonthOptions: null,

      stripe: null,
      cardElement: null,
    };
  },
  created: function () {
    this.initData();
  },
  mounted() {
    this.initStripe();
  },
  methods: {
    async initStripe() {
      this.stripe = await loadStripe(
        "pk_live_gYOa7V2Vi62Sh0VXj5QK4xkj00PCMWlrCl"
      );
      var elements = this.stripe.elements();
      this.cardElement = elements.create("card");
      this.cardElement.mount("#card-element");
      this.cardElement.on("change", function (event) {
        console.log(event);
        if (event.complete) {
          // enable payment button
        } else if (event.error) {
          // show validation to customer
        }
      });
      console.log(this.stripe);
    },
    initData() {
      this.paymentTypeOptions = [
        {
          text: "Bank ACH",
          value: 1,
        },
        {
          text: "Credit Card",
          value: 2,
        },
      ];
      this.holderTypeOptions = [
        {
          text: "individual",
          value: "individual",
        },
        {
          text: "company",
          value: "company",
        },
      ];
      this.expireYearOptions = [];
      const year = new Date().getFullYear();
      for (let i = 0; i <= 20; i++) {
        this.expireYearOptions.push({
          text: String(year + i),
          value: year + i,
        });
      }
      this.expireMonthOptions = [];
      for (let month = 1; month <= 12; month++) {
        this.expireMonthOptions.push({
          text: String(month),
          value: month,
        });
      }
    },
    buttonClick: async function () {
      if (this.editPaymentType == 1) {
        // console.log("editBankName", this.editBankName);
        // console.log("editBankHolderType", this.editBankHolderType);
        // console.log("editBankRoutingNumber", this.editBankRoutingNumber);
        // console.log("editBankAccountNumber", this.editBankAccountNumber);
        // console.log("editBankConfirmNumber", this.editBankConfirmNumber);
        if (!this.editBankAccountNumber) {
          this.$toasted.global.toast_error({
            message: "missing account number",
          });
          return;
        }
        if (
          !this.editBankConfirmNumber ||
          this.editBankConfirmNumber != this.editBankAccountNumber
        ) {
          this.$toasted.global.toast_error({
            message: "confirm number error",
          });
          return;
        }
        const data = {
          name: this.editBankName,
          holderType: this.editBankHolderType,
          accountNumber: this.editBankAccountNumber,
          routingNumber: this.editBankRoutingNumber,
        };
        this.$emit("buttonClick", this.editPaymentType, data);
      } else if (this.editPaymentType == 2) {
        const result = await this.stripe.createToken(this.cardElement);
        console.log({ result });
        if (result.error) {
          this.$toasted.global.toast_error({
            message: result.error.message,
          });
          return;
        }
        const token = result.token.id;
        if (!token) {
          this.$toasted.global.toast_error({
            message: "create token error",
          });
          return;
        }
        // if (!this.editCardNumber) {
        //   this.$toasted.global.toast_error({
        //     message: "missing card number",
        //   });
        //   return;
        // }
        // if (!this.editCardExpireMonth) {
        //   this.$toasted.global.toast_error({
        //     message: "missing card expire month",
        //   });
        //   return;
        // }
        // if (!this.editCardExpireYear) {
        //   this.$toasted.global.toast_error({
        //     message: "missing card expire year",
        //   });
        //   return;
        // }
        // if (!this.editCardCvc) {
        //   this.$toasted.global.toast_error({
        //     message: "missing card cvc",
        //   });
        //   return;
        // }
        // const data = {
        //   number: this.editCardNumber,
        //   expireMonth: this.editCardExpireMonth,
        //   expireYear: this.editCardExpireYear,
        //   cvc: this.editCardCvc,
        // };
        this.$emit("buttonClick", this.editPaymentType, { token });
      }
    },
  },
};
</script>

<style scoped>
.card-wrapper {
  background: #ffffff;
  padding: 6px 8px;
  border: 1px solid var(--border-grey-lightest);
  border-radius: 8px;
}
</style>
